/**
 * 常量定义
 */
const commons = {
  fileSizeMin: 1,
  fileSizeMax: 31457280 // 30 * 1024 * 1024 = 30M
}
export const DEBOUNCE_TIME = 300
export default commons
